var codeLogin = true // 手机验证码登录 or 邮箱手机号登录
import areaDataJson from './areaData.json'
import hotRegionJson from './hotRegion.json'
let areaData = areaDataJson.data
let hotRegion = hotRegionJson.data
import { getPlatform } from '../../tools/getPlatform'

function setComponent(options = {}) {
  let hiddenThirdLogin = options.hiddenThirdLogin
  let hiddenOtherLogin = options.hiddenOtherLogin
  let isPhone = /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(
    navigator.userAgent
  )
  let isWx = /microMessenger/i.test(navigator.userAgent)
  let url = 'https://lapp.xinli001.com/html/pintai_xieyi/login-protocol.html'
  // 用户协议链接,兼容测试app
  let privacyUrl = getPlatform().isCeShiApp
    ? 'https://lapp.xinli001.com/html/privacy/koudaixinli.html'
    : 'https://lapp.xinli001.com/html/privacy/index2.html'
  let forgetUrl = isPhone
    ? 'https://m.xinli001.com/account/forgetpwd'
    : 'https://account.xinli001.com/forgetpwd'
  let $el = `
        <div id="login-component">
            <div class="content">
                <div class="header"><p class="img"></p></div>
                <div class="login-form" >
                    <!--验证码登陆-->
                    <div class="mobileLogin">
                        <p id="area-code-box">+<span id="area-code">86</span> <span class="icon"></span></p>
                        <div class="input-wrap mobile-box">
                            <input type="text" name="mobile" placeholder="请输入手机号" maxlength="11" class="login-input" id="mobile" />
                            <span id="getCode">获取验证码</span>
                            <span id="obtain">60s后重新获取</span>
                        </div>
                        <p class="label-text">验证码</p>
                        <div class="input-wrap codeBox">
                            <input type="text" name="veri-code" maxlength="6" placeholder="请输入6位验证码" class="veri-code-input" id="veri-code" />
                        </div>
                        <div id="popup-captcha"></div>
                    </div>
                    <!--邮箱手机号登陆-->
                    <div class="emailLogin" style="display: none">
                        <p class="label-text">账号</p>
                        <div class="input-wrap account">
                            <input type="text" name="account" placeholder="请输入手机号或邮箱" class="account-input" id="account" />
                        </div>
                        <p class="label-text">密码</p>
                        <div class="input-wrap password">
                            <input type="password" name="password" placeholder="请输入登录密码" class="password-input" id="password" />
                            <a href="${forgetUrl}"><span id="forget-password">忘记密码</span></a>
                        </div>
                    </div>
                    <div class="accept-agreement">
                         <span class="icon" id="accept-agreement-icon"></span>
                         <span class="text"> 同意 <a href="${url}">《壹心理用户注册协议》</a> 和 <a  href="${privacyUrl}">《隐私政策》</a></span>

                    </div>
                </div>
                <div class="login-btn" id="login-btn">登录/注册</div>
                <p class="other" style="justify-content: ${
                  hiddenOtherLogin ? 'center' : 'space-between'
                }">
                      <span class="emailLogin " id="changeToMobileLogin" style="display:none">验证码快速登录</span>
                      <span class="mobileLogin " id="changeToEmailLogin" style="display: ${
                        hiddenOtherLogin ? 'none' : 'block'
                      }">邮箱手机号密码登录</span>
                      <a href="https://m.xinli001.com/feedback" style="display: ${
                        isPhone ? 'block' : 'none'
                      }">
                       <span>帮助与反馈</span>
                      </a>
                </p>
            </div>
            <div class="the-third-party" style="display: ${
              hiddenThirdLogin || hiddenOtherLogin ? 'none' : 'block'
            }">
                <p class="title">
                  第三方登录
                </p>
                <div class="content-icon">
                    <span class="wx" id="wx" style="display: ${
                      !isPhone || isWx ? 'block' : 'none'
                    }"></span>
                    <span class="qq" id="qq"></span>
                    <span class="weibo" id="weibo"></span>
                </div>
            </div>

            ${selectionArea(hotRegion, areaData)}
        </div>
    `
  return $el
}
function selectionArea(hotRegion = [], areaData = []) {
  let hotRegionLiMapHtml = ''
  let allLiMapHtml = ''
  hotRegion.map(item => {
    return (hotRegionLiMapHtml += `<li class="country-item"><span class="country">${item.name}</span><span class="code">+<span class="num">${item.areaCode}</span></span></li>`)
  })
  areaData.map(item => {
    return (allLiMapHtml += `<li class="country-item"><span class="country">${item.name}</span><span class="code">+<span class="num">${item.areaCode}</span></span></li>`)
  })

  let areaDiv = `
         <!-- 区号选择弹层 -->
      <div class="area-code-container">
        <div class="area-code-header">
          <span class="cancel-btn">取消</span>
          <span class="area-code-title">选择国家/地区</span>
        </div>
        <ul class="country-list">
        <li class="title">热门</li>
            ${hotRegionLiMapHtml}
          <li class="title all">全部</li>
         ${allLiMapHtml}
        </ul>
      </div>
    `
  return areaDiv
}

function componentMethods() {
  let mobileLogin = document.getElementsByClassName('mobileLogin')
  let emailLogin = document.getElementsByClassName('emailLogin')
  setTimeout(() => {
    // 切换至验证码登录
    document
      .getElementById('changeToMobileLogin')
      .addEventListener('click', () => {
        for (let a = 0; a < mobileLogin.length; a++) {
          mobileLogin[a].style.display = 'block'
        }
        for (let a = 0; a < emailLogin.length; a++) {
          emailLogin[a].style.display = 'none'
        }
        document.getElementById('login-btn').innerText = '登录/注册'
        codeLogin = true
      })
    // 切换至手机号邮箱登录
    document
      .getElementById('changeToEmailLogin')
      .addEventListener('click', () => {
        for (let a = 0; a < mobileLogin.length; a++) {
          mobileLogin[a].style.display = 'none'
        }
        for (let a = 0; a < emailLogin.length; a++) {
          emailLogin[a].style.display = 'block'
        }
        document.getElementById('login-btn').innerText = '登录'
        codeLogin = false
      })

    // 口袋心理app 审核问题 登陆页不设置默认选中
    const { isCeShiApp, isAndroid } = getPlatform()
    if (isCeShiApp && isAndroid) {
      document.getElementById('accept-agreement-icon').classList.add('before')
      document.getElementById('login-btn').classList.add('disable')
    }

    //  是否同意协议
    document
      .getElementById('accept-agreement-icon')
      .addEventListener('click', function() {
        if (this.classList.contains('before')) {
          document
            .getElementById('accept-agreement-icon')
            .classList.remove('before')
          document.getElementById('login-btn').classList.remove('disable')
        } else {
          document
            .getElementById('accept-agreement-icon')
            .classList.add('before')
          document.getElementById('login-btn').classList.add('disable')
        }
      })
    // 弹出区号选择弹层
    document
      .getElementById('area-code-box')
      .addEventListener('click', function() {
        document.querySelector('.area-code-container').className =
          'area-code-container slide-up'
      })
    //  区号选择弹层取消
    document
      .querySelector('.area-code-container .cancel-btn')
      .addEventListener('click', function() {
        document.querySelector('.area-code-container').className =
          'area-code-container slide-down'
      })
    // 区号选择弹层选择
    let countryItem = document.querySelectorAll('.country-list .country-item')
    for (let a = 0; a < countryItem.length; a++) {
      countryItem[a].addEventListener('click', function() {
        document.getElementById('area-code').innerText = this.querySelector(
          '.num'
        ).innerText
        document.querySelector('.area-code-container').className =
          'area-code-container slide-down'
      })
    }
  }, 300)
}
// 获取验证码
function getVeriCode(fn) {
  document.getElementById('getCode') &&
    document.getElementById('getCode').addEventListener('click', function() {
      fn &&
        fn(
          document.getElementById('mobile').value,
          document.getElementById('area-code').innerText
        )
    })
}

function countdownFn() {
  let countdown = 60
  let setTimeoutFn = setInterval(function() {
    if (countdown === 0) {
      document.getElementById('getCode').style.display = 'block'
      document.getElementById('obtain').style.display = 'none'
      clearInterval(setTimeoutFn)
    } else {
      document.getElementById('getCode').style.display = 'none'
      document.getElementById('obtain').style.display = 'block'
      document.getElementById('obtain').innerText = `${countdown}s后重新获取`
      countdown--
    }
  }, 1000)
}

// 手机验证码登录
function veriCodeLoginFn(fn) {
  document.getElementById('login-btn').addEventListener('click', function() {
    if (codeLogin && !this.classList.contains('disable') && fn) {
      fn(
        document.getElementById('mobile').value,
        document.getElementById('veri-code').value,
        document.getElementById('area-code').innerText
      )
    }
  })
}
// 手机验证码登录
function mobileOrEmailLoginFn(fn) {
  document.getElementById('login-btn').addEventListener('click', function() {
    if (!codeLogin && !this.classList.contains('disable') && fn) {
      fn(
        document.getElementById('account').value,
        document.getElementById('password').value
      )
    }
  })
}
// 第三方登录
function wxLogin(fn) {
  document.getElementById('wx') &&
    document.getElementById('wx').addEventListener('click', function() {
      fn && fn()
    })
}
function qqLogin(fn) {
  document.getElementById('qq').addEventListener('click', function() {
    fn && fn()
  })
}
function weiboLogin(fn) {
  document.getElementById('weibo').addEventListener('click', function() {
    fn && fn()
  })
}
export {
  setComponent,
  componentMethods,
  getVeriCode,
  veriCodeLoginFn,
  mobileOrEmailLoginFn,
  wxLogin,
  qqLogin,
  weiboLogin,
  countdownFn
}



// WEBPACK FOOTER //
// ./src/frontend-lib/component/login/index.js